import cloneDeep from 'lodash/cloneDeep';

import type { ApiSavedSearchUnsaved } from 'modules/userDashboard/api/savedSearch/types/UserDashboardApiSavedSearch';

export function removeUnsaveableFilters(search: ApiSavedSearchUnsaved) {
  const searchCloned = cloneDeep(search);
  // some action types are not saveable
  if (
    searchCloned.filters.type === 'VOLOP' &&
    searchCloned.filters.actionType
  ) {
    searchCloned.filters.actionType = searchCloned.filters.actionType.filter(
      (at) => !['DONATION', 'PETITION'].includes(at),
    );
  }
  return searchCloned;
}
